export const isProd = String(process.env.NODE_ENV)
  .toLowerCase()
  .includes("prod");
export const isDev = String(process.env.NODE_ENV).toLowerCase().includes("dev");
export const hideDevLogs = String(process.env.REACT_APP_HIDE_DEV_LOG)
  .toLowerCase()
  .includes("true");

export const isStaging = String(process.env.REACT_APP_NODE_ENV)
  .toLowerCase()
  .includes("staging");

const constant = {
  IDB_KEY: "bitmama.io",
  AUTH_TOKEN_KEY: "authToken",
  TEMP_PROFILE: "tempProfile",
  TEMP_PIN: "*tempp", // used to store tx pin temporarily to be reused without asking the user's pin everything within a context
  USER_DATA_KEY: "userData",
  FLUTTERWAVE_PUBKEY: process.env.REACT_APP_FLUTTERWAVE_PUBKEY,

  INTERCOM_TOKEN: process.env.REACT_APP_INTERCOM_TOKEN,
  INTERCOM_SECRET: process.env.REACT_APP_INTERCOM_SECRET,

  PAGES: {
    HOME: "/dashboard/home",
    APP: "/app",
    LOGIN: "/",
    FORGOT: "/forgot",
    RESET: "/reset",
    TwoFAReset: "/reset2FA",
    SIGNUP: "/signup",
    RESET_CODE: "/resetcode",
    PHONE_NUMBER: "/phonenumber",
    VERIFY_PHONE: "/confirmnumber",
    VERIFY_EMAIL: "/verifyemail",
    VERIFY_TWO_FA: "/2faenter",
    GENERATE_TWO_FA: "/2fagenerate",
    VERIFY_EMAIL_PASSWORD: "/verify-email-password",

    TECH_POINT_WIDGET: "/techpoint/widget",

    P2P: {
      HOME: "/dashboard/p2p",
    },

    BCPL: {
      ROOT: "/dashboard/bcpl",
    },

    EARN: {
      ROOT: "/dashboard/earn",
    },

    SWAP: {
      ROOT: "/dashboard/swap",
    },
  },
  coins: {
    xlm: {
      precision: 3,
      label: "XLM",
      roundValue: 0.001,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.01, minimum: 10 },
      },
    },
    xrp: {
      precision: 2,
      label: "XRP",
      roundValue: 0.01,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.00002, minimum: 15 },
      },
    },
    eth: {
      precision: 5,
      label: "ETH",
      roundValue: 0.0001,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.008, minimum: 0.02 },
      },
    },
    btc: {
      precision: 6,
      label: "BTC",
      roundValue: 0.00001,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.0005, minimum: 0.001 },
      },
    },
    teth: {
      precision: 5,
      roundValue: 0.0001,
      label: "tETH",
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.008, minimum: 0.02 },
      },
    },
    tbtc: {
      precision: 6,
      label: "tBTC",
      roundValue: 0.00001,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.0005, minimum: 0.001 },
      },
    },
    cusd: {
      precision: 2,
      label: "cUSD",
      roundValue: 0.01,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.01, minimum: 2 },
      },
    },
    ceur: {
      precision: 2,
      label: "cEUR",
      roundValue: 0.01,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.008, minimum: 0.008 },
      },
    },
    usdt: {
      precision: 2,
      label: "USDT",
      roundValue: 0.01,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 1, minimum: 5 },
      },
    },
    usdc: {
      precision: 2,
      label: "USDC",
      roundValue: 0.01,
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 20, minimum: 25 },
      },
    },
    celo: {
      precision: 3,
      label: "CELO",
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.001, minimum: 0.02 },
      },
    },
    matic: {
      precision: 5,
      label: "MATIC",
      wallet: {
        deposit: { fee: 0.008, minimum: 0.008 },
        withdraw: { fee: 0.001, minimum: 0.02 },
      },
    },
    // "usdt-tron": {
    //   precision: 5,
    //   label: "USDT TRON",
    //   wallet: {
    //     deposit: { fee: 0.008, minimum: 0.008 },
    //     withdraw: { fee: 1, minimum: 1 },
    //   },
    // },

    ngn: { precision: 2, roundValue: 0.01, label: "NGN" },
    ghs: { precision: 2, roundValue: 0.01, label: "GHS" },
    kes: { precision: 2, roundValue: 0.01, label: "KES" },
  },
  maps: {
    countryToCurrency: {
      nigeria: "ngn",
      ghana: "ghs",
      kenya: "kes",
    },
  },
  swap: {
    fee: 0.15,
  },
  // stableCoins: ["usdt", "cusd", "usdt-tron", "usdc"],
  stableCoins: ["usdt", "cusd", "usdc"],
  fiats: ["ngn", "ghs", "kes"],
  priceAlertCoins: ["btc", "eth", "celo", "xrp", "xlm"],
  supportedLoanableCoins:
    isStaging || isDev ? ["tbtc", "teth", "celo"] : ["btc", "eth", "celo"],
  supportedStakableCoins:
    isStaging || isDev ? ["tbtc", "teth", "usdt"] : ["btc", "eth", "usdt"],

  // tron: 5
  // erc: 50
};

export default constant;

// GET /auth/verify-phone
// POST - /auth/verify-phone

// GET /auth/verify-email
// POST /auth/verify-email
